import { Controller } from "@hotwired/stimulus";
import Vue from "vue/dist/vue.esm";
import axios from "axios";
import App from "../components/importer/Importer.vue";

export default class extends Controller {
  connect() {
    const el = this.element;
    Vue.use({
          install (Vue) {
          Vue.prototype.$api = axios.create({
            headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
          })
        }
      })
    this.vueInstance = new Vue({
      el,
      render: h => h(App, {
        props: {
          url: el.dataset.url,
          asset_layouts: JSON.parse(el.dataset.assetLayouts),
        }
      })
    });
  }
}
